<template>
  <div class="account-upgrade-page">
    <div class="header">
      <!-- <div class="upgrade-btn" @click="upgradeClick">Upgrade Plan</div> -->
    </div>
    <div class="main-container">
      <div class="title">{{ memberTitle }}</div>
      <div class="tip">Invite people to manage social account for you.</div>
      <team-member-des style="margin-top: 20px"></team-member-des>
      <hi-button type="text" class="invite-member-btn" @click="inviteClick"
        >Invite Member
      </hi-button>
      <div class="list-container" v-if="member.length > 0">
        <el-table class="table" :data="member">
          <el-table-column label="Email" prop="memberEmail" width="230">
          </el-table-column>
          <el-table-column label="Assigned Instagram">
            <template slot-scope="scope">
              <div class="publisher-list">
                <div
                  class="image-item"
                  v-lazy:background-image="publisher.image"
                  v-if="index <= 5"
                  v-for="(publisher, index) in scope.row.publishers"
                  :key="publisher.id"
                >
                  <div
                    v-if="publisher.socialNetwork === 1"
                    class="ins-user-icon"
                  ></div>
                  <div
                    v-if="publisher.socialNetwork === 2"
                    class="fb-page-user-icon"
                  ></div>
                  <div
                    v-if="publisher.socialNetwork === 3"
                    class="fb-group-user-icon"
                  ></div>
                  <div
                    v-if="publisher.socialNetwork === 4"
                    class="tw-user-icon"
                  ></div>
                </div>
                <instagram-popover :member="scope.row" @remove="remove">
                  <div v-if="scope.row.publishers.length > 5" class="more-btn">
                    More
                  </div>
                </instagram-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="180">
            <template slot-scope="scope">
              <div style="text-align: right">
                <hi-button @click.native="editMember(scope.row)" type="text"
                  >Edit</hi-button
                >
                <hi-button @click.native="delMemberClick(scope.row)" type="text"
                  >Delete</hi-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <invite-member-dialog ref="inviteMember"></invite-member-dialog>
  </div>
</template>

<script>
import InviteMemberDialog from "../../components/plan/team_member/InviteMemberDialog";
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import TeamMemberDes from "../../components/plan/upgrade/des/Index";
import hiButton from "../../components/common/button/Index";
import instagramPopover from "../../components/plan/team_member/InstagramPopover";
import { removeMemberPublisher, removeMember } from "../../service/member";
import { showErrorMsg } from "../../utils/errors";

export default {
  name: "AccountMemberPage",
  components: { TeamMemberDes, InviteMemberDialog, hiButton, instagramPopover },
  data() {
    const _this = this;
    return {
      memberDes: [
        _this.$t("inviteMemberPage.des1"),
        _this.$t("inviteMemberPage.des2"),
        _this.$t("inviteMemberPage.des3"),
      ],
    };
  },
  methods: {
    /**
     * invite点击事件
     */
    async inviteClick() {
      this.$refs.inviteMember.open();
    },
    /**
     * 升级按钮点击事件
     */
    upgradeClick() {
      this.$router.push({ name: "UpgradePage" });
    },
    /**
     * 编辑按钮点击事件
     */
    editMember(form) {
      this.$refs.inviteMember.open(form);
    },
    /**
     * 删除按钮回调
     */
    async remove({ id, publisherId }) {
      const loading = this.$loading();
      try {
        await removeMemberPublisher({ id, publisherId });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 删除member点击事件
     */
    async delMemberClick(member) {
      const loading = this.$loading();
      try {
        await this.$confirm.show(`${this.$t("memberDetailPage.del")}?`);
        await removeMember({ memberId: member.id });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
    /**
     * member标题
     */
    memberTitle() {
      let title = this.$t("inviteMemberPage.pageTitle");
      if (this.maxMember > 0) {
        title += ` (${this.user.teamMemberList.length}/${this.maxMember})`;
      }
      return title;
    },
    /**
     * 计算列表
     * @returns {Array}
     */
    member() {
      return this.user.teamMemberList;
    },
    /**
     * 计算最多Member数量
     */
    maxMember() {
      return this.user.plan.memberCount;
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme";

.account-upgrade-page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  min-width: 850px;
  .header {
    height: 80px;
    padding-left: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e5e5;

    .upgrade-btn {
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      background-color: #e72955;
      border-radius: 4px;
      color: white;
      cursor: pointer;

      &:active,
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .main-container {
    padding: 50px 60px;
    flex: 1;
    overflow: auto;

    .title {
      font-size: 20px;
      font-weight: 500;
    }

    .tip {
      font-size: 16px;
      color: #5a5a5a;
      margin-top: 20px;
    }

    .invite-member-btn {
      width: 232px;
      height: 40px;
      border-radius: 2px;
      border: solid 1px @border-color;
      font-size: 16px;
      margin-top: 30px;
      color: black;
    }

    .list-container {
      border-top: solid 1px @border-color;
      margin-top: 30px;
      padding: 7px 0;

      .publisher-list {
        display: flex;
        align-items: center;
        float: left;

        .image-item {
          width: 36px;
          height: 36px;
          margin-right: 10px;
          background-size: contain;
          border-radius: 50%;
          position: relative;
        }

        .more-btn {
          color: @color-primary;
          font-size: 14px;
          margin-left: 10px;
          cursor: pointer;

          &:active,
          &:hover {
            opacity: 0.8;
          }
        }
      }
    }
  }
}
</style>
